import styled from 'styled-components';

export const SupportPageStyle = styled.div`
  width: 100%;
  background: #0b0f1b;
  min-height: 100vh;
  color: #ffffff;

  .support-header {
    padding: 32px 40px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
  }

  .headContent {
    flex: 1;
    min-width: 280px;
  }

  .support-title {
    font-family: Poppins;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.02em;
    text-align: left;
    color: white;
    margin-bottom: 6px;
    line-height: 1.2;
    text-transform: uppercase;
  }

  .support-subtitle {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    color: #b8b8b8;
    line-height: 1.5;
  }

  .support-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 32px 40px 60px;
  }

  .support-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  /* FAQs Section */
  .faqs-section {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 30px;
    height: fit-content;
  }

  .section-title {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 24px;
  }

  .faqs-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .faq-item {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      border-color: rgba(0, 122, 255, 0.3);
      background: rgba(255, 255, 255, 0.07);
    }

    &.expanded {
      border-color: #007aff;
    }
  }

  .faq-question {
    padding: 18px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    transition: background 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.03);
    }
  }

  .faq-icon {
    font-size: 24px;
    font-weight: 300;
    color: #007aff;
    min-width: 24px;
    text-align: center;
    transition: transform 0.3s ease;
  }

  .faq-answer {
    padding: 0 20px 18px 20px;
    font-size: 14px;
    color: #b8b8b8;
    line-height: 1.6;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Form Section */
  .form-section {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 30px;
    height: fit-content;
  }

  .form-description {
    font-size: 14px;
    color: #b8b8b8;
    margin-bottom: 28px;
    line-height: 1.6;
  }

  .contact-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .form-label {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }

  .required {
    color: #ff4d4d;
  }

  .form-input,
  .form-select,
  .form-textarea {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    color: #ffffff;
    font-family: inherit;
    transition: all 0.3s ease;
    outline: none;

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }

    &:focus {
      border-color: #007aff;
      background: rgba(255, 255, 255, 0.08);
      box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
    }

    &:hover:not(:focus) {
      border-color: rgba(255, 255, 255, 0.2);
    }

    &.error {
      border-color: #ff4d4d;
    }
  }

  .form-select {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23ffffff' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;
    padding-right: 40px;

    option {
      background: #1a1f2e;
      color: #ffffff;
    }
  }

  .form-textarea {
    resize: vertical;
    min-height: 120px;
    line-height: 1.6;
  }

  .error-message {
    font-size: 13px;
    color: #ff4d4d;
    margin-top: -4px;
  }

  .optional {
    color: #666;
    font-weight: 400;
    font-size: 12px;
  }

  .upload-hint {
    font-size: 13px;
    color: #888;
    margin: 0 0 12px 0;
    line-height: 1.4;
  }

  /* Upload Zone */
  .upload-zone {
    border: 2px dashed rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    padding: 28px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.02);

    &:hover:not(.disabled) {
      border-color: rgba(0, 122, 255, 0.4);
      background: rgba(0, 122, 255, 0.05);
    }

    &.dragging {
      border-color: #007aff;
      background: rgba(0, 122, 255, 0.1);
      transform: scale(1.01);
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .upload-icon {
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 12px;
    transition: color 0.3s ease;

    .upload-zone:hover:not(.disabled) &,
    .upload-zone.dragging & {
      color: #007aff;
    }
  }

  .upload-text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 8px 0;
    font-weight: 500;
  }

  .upload-formats {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
  }

  /* Attachments List */
  .attachments-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 16px;
  }

  .attachment-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    transition: all 0.2s ease;
    animation: slideIn 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.12);
    }
  }

  .attachment-preview {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .file-icon {
    font-size: 22px;
  }

  .attachment-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .attachment-name {
    font-size: 13px;
    color: #ffffff;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .attachment-size {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
  }

  .attachment-remove {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: none;
    background: rgba(255, 77, 77, 0.15);
    color: #ff4d4d;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
      background: rgba(255, 77, 77, 0.25);
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  .attachment-count {
    margin-top: 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    text-align: right;
  }

  .status-message {
    padding: 14px 16px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
    animation: slideIn 0.3s ease;

    &.success {
      background: rgba(86, 186, 50, 0.15);
      border: 1px solid rgba(86, 186, 50, 0.3);
      color: #56ba32;
    }

    &.error {
      background: rgba(255, 77, 77, 0.15);
      border: 1px solid rgba(255, 77, 77, 0.3);
      color: #ff4d4d;
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .submit-button {
    background: #007aff;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 32px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 12px rgba(0, 122, 255, 0.3);
    margin-top: 8px;

    &:hover:not(:disabled) {
      background: #0056cc;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.25);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Responsive Design */
  @media (max-width: 1200px) {
    .support-container {
      padding: 24px 30px 40px;
    }

    .support-content {
      gap: 30px;
    }

    .faqs-section,
    .form-section {
      padding: 24px;
    }
  }

  @media (max-width: 900px) {
    .support-header {
      padding: 24px 20px 20px;
    }

    .support-container {
      padding: 24px 20px 40px;
    }

    .support-content {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    .faqs-section {
      order: 2;
    }

    .form-section {
      order: 1;
    }
  }

  @media (max-width: 768px) {
    .support-header {
      padding: 20px;
    }

    .support-title {
      font-size: 22px;
    }

    .support-subtitle {
      font-size: 13px;
    }
  }

  @media (max-width: 600px) {
    .support-title {
      font-size: 22px;
    }

    .section-title {
      font-size: 20px;
    }

    .faqs-section,
    .form-section {
      padding: 20px;
    }

    .faq-question {
      padding: 14px 16px;
      font-size: 14px;
    }

    .faq-answer {
      padding: 0 16px 14px 16px;
      font-size: 13px;
    }

    .form-input,
    .form-select,
    .form-textarea {
      padding: 10px 14px;
      font-size: 13px;
    }

    .submit-button {
      font-size: 15px;
      padding: 12px 28px;
    }

    .upload-zone {
      padding: 20px 16px;
    }

    .upload-icon svg {
      width: 32px;
      height: 32px;
    }

    .upload-text {
      font-size: 13px;
    }

    .upload-formats {
      font-size: 11px;
    }

    .attachment-preview {
      width: 38px;
      height: 38px;
    }

    .attachment-name {
      font-size: 12px;
    }
  }
`;
